import { BuildingOffice2Icon } from "@heroicons/react/24/outline"
import { addFieldEditor } from "aldoo-ra/CMS/field-editor-resolver"
import OrganizationField from "./OrganizationField"
import { useHasPermission } from "aldoo-ra/Permissions"

// who may move a product to another organization: the platform's admins (role:admin), never
// a vendor — the rule below asks the context this hook adds
const useSystemAdminContext = () => {
  const { hasPermission } = useHasPermission("role:admin")
  return { isSystemAdmin: hasPermission === true }
}

/**
 * Organization extension (admin side).
 *
 * Adds the Organization tab to the store product editor: which organization
 * owns the product. The server half is
 * aldoo-na/store/product/extensions/organization.
 */
addFieldEditor("OrganizationField", OrganizationField)

export const StoreProductExtension = {
  id: "organization",
  label: "Organization",
  description: "The organization that owns the product (publisher)",
  icon: BuildingOffice2Icon,
  // the platform's admins only
  visible: (context) => context?.isSystemAdmin === true,
  visibilityContext: useSystemAdminContext,
  group: {
    id: "organization",
    label: "Organization",
    description: "The organization this product belongs to.",
  },
  fields: [
    {
      id: "publisher",
      label: "Organization",
      // its own editor: the field stores an id, the editor shows the logo and name
      type: "Text",
      fieldEditor: "OrganizationField",
      description: "The organization that owns this product",
      render: { variant: "default" },
    },
  ],
}
